/** @format */

export default [
  {
    header: 'Agent',
    role: ['other'],
  },
  {
    title: 'Home',
    icon: 'HomeIcon',
    route: 'vip_home',
    role: ['other'],
  },

  {
    title: 'My Information',
    icon: 'UserIcon',
    role: ['other'],

    children: [
      {
        title: 'My Information',
        route: 'vip_info',
      },
      {
        title: 'Downline Agent',
        route: 'vip_next',
      },
      {
        title: 'Team List',
        route: 'team_list',
      },
    ],
  },
  {
    title: 'Submit my policy',
    role: ['other'],
    icon: 'CheckSquareIcon',
    route: 'vip_insurance-policy-submit',
  },
  {
    title: 'My policy',
    icon: 'FileTextIcon',
    role: ['other'],
    children: [
      {
        title: 'Policy List',
        route: 'vip_insurance-policy',
        icon: 'AwardIcon',
      },
      // {
      //   title: 'Team Awards',
      //   route: 'team_reward',
      // },
      // {
      //   title: '保单记录',
      //   route: 'vip_Commission_record',
      // },
      // {
      //   title: '支付记录',
      //   route: 'vip_Pay_record',
      // },
      {
        title: 'Commission Report',
        route: 'vip_Commission_record',
      },
    ],
  },
  {
    title: 'How to Start?',
    tagVariant: 'success',
    icon: 'FlagIcon',
    children: [
      // {
      //   title: 'Training Materials',
      //   route: 'vip_tutorial-material',
      // },
      {
        title: 'Training Videos',
        href: 'https://www.oneupus.com/about-us/',
      },
      {
        title: 'Library',
        route: 'vip_tutorial-library',
      },
    ],
  },
  {
    title: 'Licensing & Appointment',
    tagVariant: 'success',
    icon: 'FlagIcon',
    children: [
      {
        title: 'Pre-licensing',
        href: 'https://www.examfx.com/',
      },
      {
        title: 'Insurance License Exam',
        href: 'https://home.psiexams.com/#/home',
      },
      {
        title: 'Fingerprinting',
        href: 'https://www.identogo.com/services/live-scan-fingerprinting',
      },
      {
        title: 'License Application',
        href: ' https://www.sircon.com/',
      },
      {
        title: 'California Total Access Continuing Education',
        href: 'https://www.kaplanfinancial.com/insurance-continuing-education/california/total-access-ce-life-health',
      },
      {
        title: 'Errors and Omissions (E&O) Insurance',
        href: 'https://www.napa-benefits.org/insurance/errors-and-omissions-eando-insurance?utm_source=google&utm_medium=cpc&utm_campaign=napa-direct-eo-search&utm_content=brand&gclid=Cj0KCQiAr5iQBhCsARIsAPcwRONmY3bqCAw8xEu29zQWQUyuvGxoZFoXNO9JWtvFF6iC9cibMEVgvFkaAuQNEALw_wcB',
      },
      {
        title: 'License Management',
        href: 'https://accounts.surancebay.com/oauth/authorize?redirect_uri=https:%2F%2Fsurelc.surancebay.com%2Fproducer%2Foauth%3FreturnUrl%3D%252Fprofile%253FgaId%253D381%2526gaId%253D381%2526branch%253DOne%252520Up%252520Insurance%252520Agency%2526branchVisible%253Dtrue%2526branchEditable%253Dfalse%2526branchRequired%253Dtrue%2526dba%253DP%2526autoAdd%253Dfalse%2526bcc%253Dcontact%2540oneupinsurance.onmicrosoft.com%2526requestMethod%253DGET&gaId=381&client_id=surecrmweb&response_type=code',
      },
    ],
  },
  {
    title: 'Compensation Plan',
    icon: 'CheckCircleIcon',
    children: [
      {
        title: ' Commission Schedules',
        route: 'level_detail',
      },
      {
        title: 'Renewal & Excess Grid',
        route: 'level_detail_two',
      },
    ],
  },
  {
    title: 'Analysis',
    role: ['other'],
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'Downline Report',
        route: 'vip_analytics',
        tag: '21',
        tagVariant: 'warning',
      },
      {
        title: 'Commission Report',
        route: 'vip_commission-report',
      },
      {
        title: 'Scoreboards',
        route: 'vip_score-report',
      },
    ],
  },
  {
    title: 'News',
    role: ['other'],
    icon: 'GlobeIcon',
    route: 'vip_news-list',
  },
  {
    title: 'Chat',
    icon: 'MessageSquareIcon',
    route: 'vip_message-list',
  },
  {
    title: 'Calendar',
    icon: 'CalendarIcon',
    route: 'calendar',
  },
]
